
// create the config file datas here
export const CATEGORIES_DATAS = {


    // GENERAL APP COURSE CATEGORIES AND THEIR RESPECTIVE CATEGORY ITEMS. THESE STRINGS MUST MATCH
    // THE `course_category` VALUES STORED ON THE `courses` TABLE EXACTLY, SO THE "category" QUERY
    // PARAM USED BY CATEGORY_ITEMS BELOW (AND ANY OTHER CATEGORY-FILTERED LINK) ACTUALLY MATCHES
    // REAL COURSES INSTEAD OF RETURNING AN EMPTY RESULT SET.
    CATEGORIES: {
        "categoryItemOne": "Frontend Development",
        "categoryItemTwo": "Backend Development",
        "categoryItemThree": "Mobile App Development",
        "categoryItemFour": "Full-stack Development",
        "categoryItemFive": "Cloud Native Computing",
        "categoryItemSix": "Blockchain",
        "categoryItemSeven": "Product Engineering",
        "categoryItemEight": "Data Analytics"
    },


    // GENERAL APP COURSE CATEGORIES LINKS. THIS LINKS LEAD TO A PAGE WHERE USER CAN SEE ALL COURSES UNDER THAT CATEGORY
    CATEGORY_LINKS: {
        "categoryItemOne": "/category/frontend-development",
        "categoryItemTwo": "/category/backend-development",
        "categoryItemThree": "/category/mobile-app-development",
        "categoryItemFour": "/category/full-stack-development",
        "categoryItemFive": "/category/cloud-native-computing",
        "categoryItemSix": "/category/blockchain",
        "categoryItemSeven": "/category/product-engineering",
        "categoryItemEight": "/category/data-analytics"
    },



    // GENERAL APP COURSE CATEGORIES IMAGES LINKS. THIS LINKS LOADS THE CATEGORY IMAGES FOR ANY SELECTED CATEGORY.
    CATEGORY_IMAGES: {
        "categoryItemOne": "/app_images/categories_images/categorie_img_1.webp",
        "categoryItemTwo": "/app_images/categories_images/categorie_img_2.webp",
        "categoryItemThree": "/app_images/categories_images/categorie_img_3.webp",
        "categoryItemFour": "/app_images/categories_images/categorie_img_4.webp",
        "categoryItemFive": "/app_images/categories_images/categorie_img_5.webp",
        "categoryItemSix": "/app_images/categories_images/categorie_img_6.webp",
        "categoryItemSeven": "/app_images/categories_images/categorie_img_4.webp",
        "categoryItemEight": "/app_images/categories_images/categorie_img_7.webp"
    },


    // GENERAL APP INDIVIDUAL COURSE CATEGORY ITEMS. EVERY "link" BELOW RESOLVES TO
    // `/courses?category=${encodeURIComponent(<parent category label above>)}&search=${encodeURIComponent(<this item's text>)}`
    // WHICH IS THE EXACT QUERY SHAPE `getCourses()` (services/courseService.js) SENDS TO
    // `CoursesRepositories::SiteWideCoursesFetcher`, AND THE EXACT QUERY SHAPE THE COURSES PAGE
    // (pages/courses/index.js -> CourseRoom.js) READS BACK OUT OF THE URL -- SO EVERY MEGA-MENU
    // SUB-ITEM NOW LANDS ON A REAL, FILTERED COURSE LIST INSTEAD OF A DEAD "#" LINK.
    CATEGORY_ITEMS: {
        "categoryItemOne": [
          { "text": "Frontend Development", "link": "/courses?category=Frontend%20Development&search=Frontend%20Development" },
          { "text": "ReactJS", "link": "/courses?category=Frontend%20Development&search=ReactJS" },
          { "text": "Javascript mastery", "link": "/courses?category=Frontend%20Development&search=Javascript%20mastery" },
          { "text": "HTML/CSS/JAVASCRIPT", "link": "/courses?category=Frontend%20Development&search=HTML%2FCSS%2FJAVASCRIPT" },
          { "text": "NextJS", "link": "/courses?category=Frontend%20Development&search=NextJS" },
          { "text": "NestJS", "link": "/courses?category=Frontend%20Development&search=NestJS" },
          { "text": "TypeScript", "link": "/courses?category=Frontend%20Development&search=TypeScript" },
          { "text": "Dart", "link": "/courses?category=Frontend%20Development&search=Dart" },
          { "text": "Angular", "link": "/courses?category=Frontend%20Development&search=Angular" },
          { "text": "WebFlow", "link": "/courses?category=Frontend%20Development&search=WebFlow" },
        ],
        "categoryItemTwo": [
            { "text": "Backend Development with Java", "link": "/courses?category=Backend%20Development&search=Backend%20Development%20with%20Java" },
            { "text": "Backend Development with PHP", "link": "/courses?category=Backend%20Development&search=Backend%20Development%20with%20PHP" },
            { "text": "Backend Development with Python", "link": "/courses?category=Backend%20Development&search=Backend%20Development%20with%20Python" },
            { "text": "Backend Development with NodeJS", "link": "/courses?category=Backend%20Development&search=Backend%20Development%20with%20NodeJS" },
            { "text": "PHP", "link": "/courses?category=Backend%20Development&search=PHP" },
            { "text": "Laravel Framework", "link": "/courses?category=Backend%20Development&search=Laravel%20Framework" },
            { "text": "CodeIgniter", "link": "/courses?category=Backend%20Development&search=CodeIgniter" },
            { "text": "Java", "link": "/courses?category=Backend%20Development&search=Java" },
            { "text": "springboot Framework", "link": "/courses?category=Backend%20Development&search=springboot%20Framework" },
        ],
        "categoryItemThree": [
            { "text": "React Native", "link": "/courses?category=Mobile%20App%20Development&search=React%20Native" },
            { "text": "Flutter", "link": "/courses?category=Mobile%20App%20Development&search=Flutter" },
            { "text": "Kotlin", "link": "/courses?category=Mobile%20App%20Development&search=Kotlin" },
            { "text": "Swift", "link": "/courses?category=Mobile%20App%20Development&search=Swift" },
        ],
        "categoryItemFour": [
            { "text": "Laravel", "link": "/courses?category=Full-stack%20Development&search=Laravel" },
            { "text": "Express", "link": "/courses?category=Full-stack%20Development&search=Express" },
            { "text": "Mern Stack", "link": "/courses?category=Full-stack%20Development&search=Mern%20Stack" },
            { "text": "React/Next & PHP/Laravel", "link": "/courses?category=Full-stack%20Development&search=React%2FNext%20%26%20PHP%2FLaravel" },
            { "text": "React/Next & Java/SpringBoot", "link": "/courses?category=Full-stack%20Development&search=React%2FNext%20%26%20Java%2FSpringBoot" },
            { "text": "React/Next & Python/Django", "link": "/courses?category=Full-stack%20Development&search=React%2FNext%20%26%20Python%2FDjango" },
            { "text": "React/Next & NodeJS", "link": "/courses?category=Full-stack%20Development&search=React%2FNext%20%26%20NodeJS" },
            { "text": "Vue & PHP/Laravel", "link": "/courses?category=Full-stack%20Development&search=Vue%20%26%20PHP%2FLaravel" },
            { "text": "Vue & Java/SpringBoot", "link": "/courses?category=Full-stack%20Development&search=Vue%20%26%20Java%2FSpringBoot" },
            { "text": "Vue & Python/Django", "link": "/courses?category=Full-stack%20Development&search=Vue%20%26%20Python%2FDjango" },
            { "text": "Vue & NodeJS", "link": "/courses?category=Full-stack%20Development&search=Vue%20%26%20NodeJS" },
        ],
        "categoryItemFive": [
            { "text": "GCP", "link": "/courses?category=Cloud%20Native%20Computing&search=GCP" },
            { "text": "AWS", "link": "/courses?category=Cloud%20Native%20Computing&search=AWS" },
            { "text": "Azure", "link": "/courses?category=Cloud%20Native%20Computing&search=Azure" },
            { "text": "Kubernetes K8s", "link": "/courses?category=Cloud%20Native%20Computing&search=Kubernetes%20K8s" },
            { "text": "Docker", "link": "/courses?category=Cloud%20Native%20Computing&search=Docker" },
            { "text": "CI/CD", "link": "/courses?category=Cloud%20Native%20Computing&search=CI%2FCD" },
        ],
        "categoryItemSix": [
            { "text": "Blochchain beginner", "link": "/courses?category=Blockchain&search=Blochchain%20beginner" },
            { "text": "Blockchain Development", "link": "/courses?category=Blockchain&search=Blockchain%20Development" },
            { "text": "Solidity", "link": "/courses?category=Blockchain&search=Solidity" },
            { "text": "Rust", "link": "/courses?category=Blockchain&search=Rust" },
        ],
        "categoryItemSeven": [
            { "text": "Product Management", "link": "/courses?category=Product%20Engineering&search=Product%20Management" },
            { "text": "Product Design", "link": "/courses?category=Product%20Engineering&search=Product%20Design" },
            { "text": "UI & UX", "link": "/courses?category=Product%20Engineering&search=UI%20%26%20UX" },
        ],
        // NOTE: this category used to be "Kindergarten" with sub-items "HTML & CSS" / "Javascript
        // for Kids" -- both replaced (per explicit approval) along with the top-level label, since
        // those sub-items don't correspond to anything under the new "Data Analytics" label and
        // would otherwise leave the mega-menu pointing at nonsensical search terms.
        "categoryItemEight": [
            { "text": "Python for Data Analysis", "link": "/courses?category=Data%20Analytics&search=Python%20for%20Data%20Analysis" },
            { "text": "MySQL for Data Analytics", "link": "/courses?category=Data%20Analytics&search=MySQL%20for%20Data%20Analytics" },
            { "text": "Data Visualization", "link": "/courses?category=Data%20Analytics&search=Data%20Visualization" },
            { "text": "Pandas & NumPy", "link": "/courses?category=Data%20Analytics&search=Pandas%20%26%20NumPy" },
        ]

    }


};